module.exports = __webpack_public_path__ + "static/019-0572782d33b91f9f0066d8e5ce9714ce.jpg";